<template>
    <div class="animated fadeIn">
        <loader v-if="isOverlay"></loader>
        <b-row>
            <b-col>
                <transition name="fade">
                    <b-card
                        border-variant="info"
                        header-bg-variant="primary"
                        header-text-variant="white"
                    >
                        <div slot="header">
                            <span data-font="20">Bulk Item Creation</span>
                            <b-button
                                @click="$router.push({ path: '/item' })"
                                style="font-size: 15px"
                                variant="primary"
                                class="float-right"
                                >Go Back</b-button
                            >
                        </div>
                        <div slot="header"></div>
                        <b-tabs v-model="tabIndex" v-on:input="tabActivated">
                            <b-tab title="Upload Bulk Item">
                                <b-row>
                                    <b-col>
                                        <transition name="fade">
                                            <b-card
                                                border-variant="info"
                                                header-bg-variant="primary"
                                                header-text-variant="white"
                                            >
                                                <b-row>
                                                    <b-col md="5" class="my-1">
                                                        <b-form-group
                                                            label-cols-sm="3"
                                                            class="mb-0"
                                                        >
                                                            <b-input
                                                                readonly
                                                                :value="`Category : ${catalogData.name}`"
                                                            ></b-input>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col md="2" class="my-1">
                                                        <b-button
                                                            variant="primary"
                                                            @click="
                                                                downloadTemplate
                                                            "
                                                            >Download Template
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col md="6" class="my-1">
                                                        <b-form-file
                                                            placeholder="Select an Images Zip File"
                                                            @change="
                                                                selectZipFile
                                                            "
                                                            drop-placeholder="Drop file here..."
                                                        ></b-form-file>
                                                    </b-col>
                                                    <b-col md="6" class="my-1">
                                                        <b-form-file
                                                            placeholder="Select CSV File"
                                                            @change="selectFile"
                                                            drop-placeholder="Drop file here..."
                                                        ></b-form-file>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col class="text-center">
                                                        <b-button
                                                            variant="primary"
                                                            :disabled="
                                                                !selectedFile ||
                                                                !selectedZipFile
                                                            "
                                                            @click="uploadFile"
                                                            >Upload
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-card>
                                        </transition>
                                    </b-col>
                                </b-row>

                                <section class="mt-4">
                                    <component-header
                                        title="Import History"
                                        @search-query="(val) => (filter = val)"
                                        :isLoading="loading"
                                        @reload-data="getBulkItemList"
                                        :hasCreate="false"
                                    />
                                    <b-card
                                        class="card-wrap"
                                        border-variant="info"
                                    >
                                        <b-row>
                                            <b-col md="2">
                                                <b-form-group
                                                    label-cols-sm="3"
                                                    class="mb-0"
                                                >
                                                    <label>Time Period</label>
                                                    <eb-select
                                                        type="select"
                                                        v-model="selectedPeriod"
                                                        :options="periodList"
                                                        label="text"
                                                        :id="'selecttime'"
                                                        :selected="
                                                            selectedPeriod
                                                        "
                                                        @input="getBulkItemList"
                                                    ></eb-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="2">
                                                <label>Status</label>
                                                <eb-select
                                                    type="select"
                                                    v-model="selectedStatus"
                                                    :options="statusTypes"
                                                    label="text"
                                                    :id="'selectstatus'"
                                                    :selected="selectedStatus"
                                                    @input="getBulkItemList"
                                                ></eb-select>
                                            </b-col>
                                        </b-row>
                                        <div>
                                            <b-table
                                                :fields="Columns"
                                                :items="bulkReportList"
                                                :dark="false"
                                                :filter="filter"
                                                :hover="true"
                                                thead-class="header"
                                                :striped="false"
                                                :bordered="true"
                                                :current-page="currentPage"
                                                :per-page="10"
                                                :small="false"
                                                show-empty
                                                :fixed="false"
                                            >
                                                <template
                                                    slot="cell(createdAt)"
                                                    slot-scope="data"
                                                >
                                                    <div>
                                                        {{
                                                            data.item.createdAt
                                                                | formatedate
                                                        }}
                                                    </div>
                                                </template>
                                                <template
                                                    slot="cell(inputSheet)"
                                                    slot-scope="data"
                                                >
                                                    <b-button
                                                        variant="primary"
                                                        @click="
                                                            downloadSheet(
                                                                data.item
                                                                    .inputSheet,
                                                            )
                                                        "
                                                        >Download
                                                    </b-button>
                                                </template>
                                                <template
                                                    slot="outputSheet"
                                                    slot-scope="data"
                                                >
                                                    <b-button
                                                        variant="primary"
                                                        @click="
                                                            downloadSheet(
                                                                data.item
                                                                    .outputSheet,
                                                            )
                                                        "
                                                        >Download
                                                    </b-button>
                                                </template>
                                                <template
                                                    slot="paymentResponse.paymentMode"
                                                    slot-scope="data"
                                                >
                                                    <div>
                                                        {{
                                                            data.item
                                                                .paymentResponse
                                                                .paymentMode
                                                                | formatMode
                                                        }}
                                                    </div>
                                                </template>
                                                <template slot="cell(empty)">
                                                    <div
                                                        v-if="loading"
                                                        class="text-center"
                                                    >
                                                        <span
                                                            ><b
                                                                >Loading...</b
                                                            ></span
                                                        >
                                                    </div>
                                                    <div
                                                        v-else
                                                        class="text-center"
                                                    >
                                                        No data available.
                                                    </div>
                                                </template>
                                            </b-table>
                                        </div>
                                        <div style="float: right">
                                            <b-pagination
                                                v-model="currentPage"
                                                :per-page="10"
                                                :total-rows="
                                                    bulkReportList.length
                                                "
                                                aria-controls="my-table"
                                                prev-text="Prev"
                                                next-text="Next"
                                            ></b-pagination>
                                        </div>
                                    </b-card>
                                </section>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";
import * as FileSaver from "file-saver";
import Vue from "vue";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";

export default {
    name: "BulkItemCreate",
    components: {
        AtomSpinner,
        ebSelect,
        ComponentHeader,
        loader,
    },
    data: () => {
        return {
            tabIndex: 0,
            transProps: {
                name: "flip-list",
            },
            isOverlay: false,
            loading: false,
            selectedFile: null,
            selectedZipFile: null,
            selectedImageFile: null,
            uploadedZipFile: null,
            catalogData: {},
            uploadedURL: "",
            statusTypes: ["PROCESSED", "PROCESSING", "UPLOADED"],
            selectedStatus: "PROCESSED",
            currentPage: 1,
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
            filter: "",
        };
    },
    methods: {
        ...mapActions({
            DownloadTemplate: "item/downloadItemTemplate",
            UploadFile: "inventory/uploadFileToStorage",
            bulkImport: "item/bulkItemImport",
        }),
        downloadSheet(URL) {
            window.open(URL, "_blank");
        },
        tabActivated() {
            document.getElementById("upload-image").value = "";
            this.selectedImageFile = "";
            this.uploadedURL = "";
        },
        getBulkItemList() {
            this.loading = true;
            let payload = {
                days: this.selectedPeriod.value,
                status: this.selectedStatus,
            };
            this.$store
                .dispatch("item/getBulkReport", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        downloadTemplate() {
            this.loading = true;
            this.DownloadTemplate(this.$route.params.id)
                .then((res) => {
                    this.loading = false;
                    FileSaver.saveAs(
                        res,
                        `${this.catalogData.name}_template.xlsx`,
                    );
                })
                .catch(() => (this.loading = false));
        },
        selectFile(event) {
            setTimeout(() => {
                this.selectedFile = event.target.files[0];
            }, 500);
        },
        selectZipFile(event) {
            setTimeout(() => {
                this.selectedZipFile = event.target.files[0];
            }, 500);
        },
        async uploadFile() {
            let formdata = new FormData();
            formdata.append("imageArchiveFile", this.selectedZipFile);
            formdata.append("dataFile", this.selectedFile);
            formdata.append("catalogId", this.$route.params.id);
            formdata.append("name", this.$currentUserData.userName);
            this.showCustomToast();
            this.isOverlay = true;
            this.bulkImport(formdata)
                .then((res) => {
                    this.isOverlay = false;
                    this.clearCustomToast();
                    this.$swal({
                        type: "success",
                        text: "Bulk Items Created Successfully!",
                    });
                    this.selectedFile = null;
                    this.selectedZipFile = null;
                    this.getBulkItemList();
                })
                .catch(() => {
                    this.loading = false;
                    this.isOverlay = false;
                });
        },
        async getCatalog() {
            await this.$store
                .dispatch("catalog/fetchCatalogById", this.$route.params.id)
                .then((result) => {
                    if (result.status === 1) {
                        this.catalogData = result.response;
                    }
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
    },
    computed: {
        Columns() {
            return [
                {
                    key: "jobType",
                    label: "Job Type",
                    sortable: false,
                },
                {
                    key: "importedBy.name",
                    label: "Imported By",
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: false,
                },
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                },
                {
                    key: "inputSheet",
                    label: "Input Sheet",
                    sortable: false,
                },
                {
                    key: "outputSheet",
                    label: "Output Sheet",
                    sortable: false,
                },
            ];
        },
        bulkReportList() {
            let dataList = this.$store.getters["item/GetBulkItemReport"];
            if (dataList && dataList.length > 0) {
                return dataList.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
                );
            } else {
                return [];
            }
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
    mounted: async function () {
        this.getCatalog();
        this.getBulkItemList();
    },
};
</script>

<style>
.mymodalclass > div {
    margin-top: 45px !important;
}
.text-center {
    text-align: center !important;
}
[data-font="20"] {
    font-size: 20px;
}
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}

table.table-bordered > tbody > tr {
    /* text-transform: capitalize; */
    text-align: center;
}
table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
</style>
<style></style>
